import React, { useEffect, useRef, useState } from 'react';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';

const Feedback = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Hide success or error message after 3 seconds
  useEffect(() => {
    if (status) {
      const timer = setTimeout(() => {
        setStatus(null); // Reset status after 3 seconds (message disappears)
        setOpen(false);
      }, 3000);
      return () => clearTimeout(timer); // Clean up timer on component unmount or status change
    }
  }, [status]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const email = localStorage.getItem('email');
    const authToken = localStorage.getItem('authToken');
    const userAgent = navigator.userAgent;

    if (!email || !authToken) {
      setStatus('error');
      return;
    }

    const note = message;

    try {
      const response = await fetch('https://beta.flowlogic.com/api/users/add-note/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`,
        },
        body: JSON.stringify({ note, user_agent: userAgent }),
      });

      if (response.ok) {
        setStatus('success');
        setMessage('');
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div ref={dropdownRef} style={{ position: 'relative', marginRight: '10px' }}>
      {/* <FeedbackOutlinedIcon
        titleAccess="Feedback"
        style={{ cursor: 'pointer', color: '#444343' }}
        onClick={() => setOpen((prev) => !prev)}
      /> */}
      <a href="#"  onClick={() => setOpen((prev) => !prev)}>
          <img  src="/assets/feedback.svg" alt="Feedback" />
      </a>
      {open && (
        <div
          style={{
            position: 'absolute',
            top: '35%',
            right: 0,
            marginTop: '10px',
            width: '320px',
            backgroundColor: '#fff',
            border: '1px solid #ddd',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 1000,
            padding: '1.25rem',
            fontSize: '14px',
            lineHeight: '1.5',
          }}
        >
          <h4 style={{ margin: '0 0 10px', fontSize: '16px' }}>We Value Your Feedback!</h4>
        
          {status === 'success' && (
            <p style={{ color: 'green', marginBottom: '10px' }}>
              Thank you! Your feedback was submitted.
            </p>
          )}
          {status === 'error' && (
            <p style={{ color: 'red', marginBottom: '10px' }}>
              Something went wrong. Please try again.
            </p>
          )}

          <form onSubmit={handleSubmit}>
            <textarea
              rows="4"
              placeholder="Share your thoughts..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #ccc',
                resize: 'none',
                marginBottom: '10px',
              }}
            />
            <button
              type="submit"
              style={{
                width: '100%',
                padding: '8px 12px',
                backgroundColor: '#1C8F7D',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
              }}
            >
              Submit Feedback
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default Feedback;
